import React from 'react';

import autoBind from 'react-autobind';
import { PannellumVideo } from "pannellum-react";

// import other components within the same project here

class PannellumVideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  render() {
    return (
      <div style={{width:'100%', height:'100%'}}>
        <PannellumVideo
          ref="pannellumVideo"
          width="100%"
          height="100%"
          video={this.props.url}
          autoplay={false}
          controls={true}
        />
      </div>
    )
  }
}

export default PannellumVideoPlayer;
